export const accessibilityLocales = {
  'audio': "Votre navigateur doit supporter l'élement audio pour lire ce fichier.",
};
